import SchoolInfo from "../../../models/SchoolInfo";

export function hasSchool(state: SchoolInfo | null) {
  return !!state;
}

export function getSchoolId(state: SchoolInfo | null) {
  return state?.schoolId;
}

export function getSchoolName(state: SchoolInfo | null) {
  return state?.name;
}

export function getSchoolLocalAuthority(state: SchoolInfo | null) {
  return state?.localAuthority;
}

export function getSchoolTown(state: SchoolInfo | null) {
  return state?.town;
}

export function isSchoolInternational(state: SchoolInfo | null) {
  return state?.internationalSchool;
}

export function getSchoolMat(state: SchoolInfo | null) {
  return state?.mat;
}

export function isSchoolPrivate(state: SchoolInfo | null) {
  return state?.privateSchool;
}

export function getSchoolUrn(state: SchoolInfo | null) {
  return state?.urn;
}
